const BASE_URL = `${window.location.protocol}//${window.location.host}`;

// This is made for possible future expansion, once we start adding more languages.
export async function getAllAvailableLanguages() {
    const languages = [
        "en-GB"
    ]

    return languages;
}